module.exports = __webpack_public_path__ + "img/943.5144473c.jpg";